import coreAction from './core';

export default coreAction;